import React, {Component} from "react";

class Modal extends Component {


    /**
     * Class constructor
     * @param props
     */
    constructor(props) {
        super(props);
        this.onCloseModal = this.onCloseModal.bind(this);
    }


    /**
     * This method runs after the component output has been rendered to the DOM.
     */
    componentDidMount() { }


    /**
     * Method to close modal
     */
    onCloseModal(){
        this.props.closemodal();
        //e.target.closest('.modal').classList.remove('show-modal');
    }


    /**
     * This method render the information (data from previous functions) with HTML code
     *
     * @returns page with information inside HTML
     */
    render() {
        if(!this.props.show){
            return null;
        }
        return (
            <div>
                <div className={'modal ' + this.props.cssclassshow} ref={modal=> this.modal = modal} id="filmeDetailModal" tabIndex="-1" role="dialog">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h1 className="modal-title">
                                    <span>{this.props.modaltitle}</span>
                                </h1>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <span>{this.props.modalcover}</span> <br />
                                <p>{this.props.modalbody}</p>
                                <hr />
                                <p><strong>Título Original: </strong>{this.props.modalmovieoriginaltitle}</p>
                                <p><strong>Data Lançamento: </strong>{this.props.modalmoviereleasedate}</p><br />

                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-success" data-dismiss="modal" >Ver Filme</button>
                                <button type="button" className="btn btn-danger" data-dismiss="modal" onClick={this.onCloseModal}>Fechar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default Modal;
